<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Assigned To</span>
            <el-button class="white-btn" size="small" @click="edit = true;editdet()">Edit</el-button>
        </template>
        <el-card class="assigned-box" shadow="never" v-if="enquiry.assignedto!=null">
            <el-avatar shape="square" size="large" :src="enquiry.assignedto.imageurl" />
            <div class="details">
                <h6>{{ enquiry.assignedto.name }}</h6>
                <p>{{ enquiry.assignedto.mobile  }}</p>
                <p>{{ enquiry.assignedto.email }}</p>
                <p>Assigned on : {{ enquiry.assigned_on  }}</p>
            </div>
        </el-card>

    </el-card>

    <el-dialog
        v-model="edit"
        title="Assign To"
        width="500"

    >
        <el-form
            ref="ruleFormRef"
            :model="form"
            status-icon
            :rules="rules"
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"

        >
            <el-form-item label="Agent" prop="assigned_to">
                <Select2   v-model="form.assigned_to" style="width:100%"  :settings="setting" required/>
            </el-form-item>

        </el-form>
        <template #footer>
            <div class="dialog-footer">

                <el-button type="primary" @click="submitForm">
                    Assign
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {
    ElAvatar,ElCard,ElTag,ElRow,ElCol,ElButton,ElDialog,ElForm,ElFormItem,ElInput,ElSelect,ElOption
} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import $ from "jquery";

export default {
    name: "EnquiryAssign",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElAvatar,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,Edit,ElDialog,ElForm,ElFormItem,ElInput },
    data() {
        return {
            loading:false,
            edit:false,
            states:[],
            cities:[],
            form:{
                assigned_to:'',

            },
            rules:{
                assigned_to: [
                    {
                        required: true, message: 'Select Agent',
                        trigger: ['blur','change'],
                    }
                ],

            },
            setting:{
                ajax: {
                    url: '/myusers',
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            })
                        };
                    },
                    cache: true
                }
            }

        }
    },
    created(){

    },
    methods:{

        editdet(){
            this.form.assigned_to='';



        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.save()
                } else {
                    return false
                }
            })


        },
        save(){
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/saveenquirydetails?id='+this.enquiry.id,this.form).then(function (response) {


                toastr.success('Enquiry Assigned Succesfully.');
                currentObj.$emit("saved");
                currentObj.loading=false;
                currentObj.edit=false;
            })
                .catch(function (error) {
                    currentObj.loading=false;
                    toastr.error('Something Wrong try again.');
                });

        }
    }
}
</script>

<style scoped>

</style>
